import { setDeliveryZone } from '@/_store/common/common.slice';
import { getCheckPointDeliveryZones } from '@/_service/zone.service';
import { IRedux } from '@/_store/types';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

interface UseZoneErrorParams {
  shipperId: string;
}

export function useZoneError({ shipperId }: UseZoneErrorParams) {
  const [zoneError, setZoneError] = useState(false);
  const dispatch = useDispatch();

  const { order_type, activeAddress, deliveryZone } = useSelector(
    (state: IRedux) => ({
      order_type: state.session.order_type,
      activeAddress: state.common.points?.find((item) => item.isActive),
      deliveryZone: shipperId ? state.common.deliveryZones?.[shipperId] ?? null : null,
    }),
    shallowEqual
  );

  const { data: deliveryZones } = useQuery({
    queryKey: [
      'delivery-zones',
      activeAddress?.location?.[0],
      activeAddress?.location?.[1],
      order_type?.type,
      shipperId,
    ],
    queryFn: () =>
      getCheckPointDeliveryZones(
        {
          lat: activeAddress?.location?.[0],
          lon: activeAddress?.location?.[1],
        },
        shipperId
      ),
    select: (res) => res?.data,
    enabled:
      order_type?.type === 'delivery' &&
      Boolean(activeAddress?.location?.[0] && activeAddress?.location?.[1]),
  });

  useEffect(() => {
    if (deliveryZones && order_type?.type === 'delivery') {
      if (deliveryZones?.all_count > 0 && !deliveryZones?.result?.length) {
        setZoneError(true);
      } else {
        setZoneError(false);
      }

      const currentZone = deliveryZones?.result?.[0];

      if (currentZone?.id && shipperId) {
        dispatch(
          setDeliveryZone({
            shipper_id: shipperId,
            zone: {
              id: currentZone?.id,
              min_order_amount: currentZone?.min_order_amount,
            },
          })
        );
      } else if (deliveryZone?.id && shipperId) {
        dispatch(setDeliveryZone({ shipper_id: shipperId, zone: null }));
      }
    } else {
      setZoneError(false);
    }
  }, [deliveryZones, order_type?.type, shipperId]);

  return zoneError;
}
